import { ViewBioModaL } from './viewBioModal'

export { ViewBioModaL }
